<template>
  <div>
    <div class="row d-flex align-items-center">
      <div class="col-6">
        <b>{{ getTranslatedText('tax') }}</b>
      </div>
      <div class="col-6">
        <div class="d-flex justify-content-end p-2">
          <b>{{ fixedNumber(item.tax) }}</b>
        </div>
      </div>
    </div>
    <div class="row d-flex align-items-center">
      <div class="col-6">
        <b>{{ getTranslatedText('wagger after tax') }}</b>
      </div>
      <div class="col-6">
        <div class="d-flex justify-content-end p-2">
          <b>{{ fixedNumber(item.wagerAfterTax) }}</b>
        </div>
      </div>
    </div>
    <div class="row align-items-center">
      <div class="col-6">
        <b>{{ getTranslatedText('possible winnings') }}</b>
      </div>
      <div class="col-6">
        <div class="d-flex justify-content-end p-2">
          <b>{{ fixedNumber(item.possibleWinnings) }}</b>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import languageMixins from "@/mixins/language/language-mixins";
import { fixedNumber } from "@/utils/utils";

export default {
  mixins: [languageMixins],
  name: 'BetslipWinningsWithTax',
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  methods: {
    fixedNumber
  }
};
</script> 